import { Surface, SurfaceClipShadow } from '@partful/shared/ui/Surface';
import { useTenant } from '@providers/Tenant';
import { useUser } from '@providers/User';
import { ComponentProps } from 'react';
import samsonLogoUrl from 'src/assets/logo-default.svg';
import styles from './PageBrandedPanel.module.scss';

export function PageBrandedPanel({ children }: Readonly<Pick<ComponentProps<'div'>, 'children'>>) {
  const { logoUrl } = useUser();
  const { name: tenantName } = useTenant();

  return (
    <SurfaceClipShadow shadow="large" className={styles.container}>
      <Surface clip="bottom-right" clipSize="large" glass className={styles.panel}>
        <div className={styles.branding}>
          <img src={logoUrl ?? samsonLogoUrl} alt={tenantName} />
        </div>
        {children}
      </Surface>
    </SurfaceClipShadow>
  );
}
